import http from '@/utils/services/http'

export default {
  find (id) {
    id = parseInt(id)
    if (id < 1) return Promise.reject()
    return http.get('/api/leiloes/' + id) // ?XDEBUG_SESSION_START=ps
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },
  findSimple (id) {
    id = parseInt(id)
    if (id < 1) return Promise.reject()
    return http.get('/api/leiloes/' + id + '/simple') // ?XDEBUG_SESSION_START=ps
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },

  lista (limit, page, filtros) {
    let url = '/api/leiloes?page=' + page + '&limit=' + limit + filtros
    console.log(url)
    return http.get(url) // ?XDEBUG_SESSION_START=ps
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },

  buscaCategorias () {
    return http.get('/api/leiloes/categorias')
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },

  buscaComitentes () {
    return http.get('/api/comitentes/simple')
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },

  buscaTipos () {
    return http.get('/api/leiloes/cadastro/tipos')
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },
  cadastro (leilao, id) {
    if (typeof id !== 'undefined') {
      return this.atualizacao(leilao, id)
    }
    return http.post('/api/leiloes', leilao)
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },
  atualizacao (data, id) {
    return http.patch('/api/leiloes/' + id, data)
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },
  uploadArquivosLeilao (leilao, formData) {
    return http.post('/api/leiloes/' + leilao + '/arquivosPreCadastro', formData, {headers: {'Content-Type': 'multipart/form-data'}}) // ?XDEBUG_SESSION_START=ps
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },

  atualizaStatusLeilao (id, status) {
    id = parseInt(id)
    if (id < 1) return Promise.reject()
    return http.get('/api/leiloes/' + id + '/status/' + status)
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },

  uploadDocumentoLeilao (leilao, nome, file) {
    return http.post('/api/leiloes/' + leilao + '/documento', file, {headers: {'Content-Type': 'multipart/form-data'}}) // ?XDEBUG_SESSION_START=ps
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },
  deleteDocumentoLeilao (leilao, id) {
    return http.delete('/api/leiloes/' + leilao + '/documento/' + id)
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },

  // Lote
  findLote (leilaoId, id) {
    id = parseInt(id)
    if (id < 1) return Promise.reject()
    return http.get('/api/leiloes/' + leilaoId + '/lotes/' + id) // ?XDEBUG_SESSION_START=ps
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },
  setFotoDestaque (leilao, lote, id) {
    id = parseInt(id)
    if (id < 1) return Promise.reject()
    return http.post('/api/leiloes/' + leilao + '/lotes/' + lote + '/updateFotoDestaque/' + id) // ?XDEBUG_SESSION_START=ps
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },
  uploadFotoLote (leilao, lote, foto) {
    return http.post('/api/leiloes/' + leilao + '/lotes/' + lote + '/uploadFoto', foto, {headers: {'Content-Type': 'multipart/form-data'}}) // ?XDEBUG_SESSION_START=ps
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },
  deleteFotoLote (leilao, lote, foto) {
    return http.delete('/api/leiloes/' + leilao + '/lotes/' + lote + '/foto/' + foto)
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },
  atualizaDestaque (leilao, lote, value) {
    return http.post('/api/leiloes/' + leilao + '/lotes/' + lote + '/destaque', {destaque: value})
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },
  atualizaStatusLote (leilao, lote, status, estadoLote = null) {
    let param = estadoLote ? `?estadoLote=${estadoLote}` : ''
    return http.post(`/api/leiloes/${leilao}/lotes/${lote}/status/${status}${param} `)
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },
  getLoteLances (leilao, lote) {
    return http.get('/api/leiloes/' + leilao + '/lotes/' + lote + '/lances')
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },
  getLeilaoLances (leilao, lote) {
    let extra = typeof lote !== 'undefined' ? '?lote=' + parseInt(lote) : ''
    return http.get('/api/leiloes/' + leilao + '/lances' + extra)
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },
  deleteLance (id, motivo) {
    return http.delete('/api/lance/' + id, {params: {motivo: motivo}})
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },
  deleteAllLances (id, motivo) {
    return http.delete('/api/zerar-lance/' + id, {params: {motivo: motivo}})
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },

  buscaTiposBem () {
    return http.get('/api/tipobem')
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },
  buscaCamposTiposBem (tipoBemId) {
    return http.get('/api/tipobem/' + tipoBemId + '/campos')
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },
  buscaMarcas (tipoBemId) {
    return http.get('/api/tipobem/' + tipoBemId + '/marcas')
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },
  buscaModelos (marcaId) {
    return http.get('/api/marca/' + marcaId + '/modelos')
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },

  cadastroLote (lote, id) {
    if (typeof id !== 'undefined') {
      return this.atualizacaoLote(lote, id)
    }
    return http.post('/api/lotes', lote)
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },
  atualizacaoLote (data, id) {
    return http.patch('/api/lotes/' + id, data)
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },
  pendenciasComitenteMonitor (id) {
    return http.get('/api/pregao/pendenciasComitenteMonitor/' + id)
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },

  excluirLotes (leilao, lotes) {
    return http.post('/api/leiloes/' + leilao + '/excluirLotes', lotes)
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },
  copiarLote (leilao, novoLeilao, lote) {
    return http.post('/api/leiloes/' + leilao + '/' + novoLeilao + '/copiarLote', {id: lote})
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },
  relatorioSaida (leilao) {
    return http.get('/api/leiloes/' + leilao + '/relatorios/saida')
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },
  renovaCache (leilao) {
    return http.put('/api/leiloes/' + leilao + '/cache/renovar')
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },
  importar (data, cbUploadProgress) {
    return http.post('/api/leiloes/importar', data, {
      headers: {'Content-Type': 'multipart/form-data'},
      onUploadProgress: cbUploadProgress
    })
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },
  importarProcessar (file) {
    return http.put('/api/leiloes/importar', {file: file})
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },
  importarLeilao (importador, dados) {
    return http.post('/api/leiloes/importarLeilao?importador=' + importador, dados)
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },
  importarLote (importador, dados) {
    return http.post('/api/leiloes/importarLote?importador=' + importador, dados, {'timeout': 50000})
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },
  gerarCobranca (leilao, lote) {
    return http.get('/api/leiloes/' + leilao + '/' + lote + '/gerarCobrancaView')
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },
  enviarEmailComunicacaoLote (lote, dados) {
    return http.post('/api/lote/comunicador/send', dados)
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },
  checaComunicacaoLote (leilao) {
    return http.get(`/api/leilao/${leilao}/comunicador/check`)
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },
  checaLeiloesAbertos () {
    return http.get(`/api/leilao/check/abertos`)
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },
  enviaAvisosComunicacao (lote) {
    /* console.log(`Enviando lote ${lote}`)
    return new Promise(resolve => setTimeout(resolve, 3000)) */
    return http.post(`/api/lote/${lote}/comunicador/sendIndividual`)
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },
  updateVideoDestaque (lote, video) {
    return http.post(`/api/lote/${lote}/videoDestaque`, {video: video})
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },
  updateUrlVideoComitente (url) {
    return http.post(`/api/comitente/updateVideoUrl`, {url: url})
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },
  deleteAprovacaoComitente (lote) {
    return http.delete(`/api/comitente/deleteAprovacao/${lote}`)
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },
  getLeilaoResumo (leilao) {
    return http.get('/api/leiloes/' + leilao + '/relatorio/resumo')
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },
  iniciaSincronizacaoLocal (leilao, config) {
    return http.post('/api/leiloes/' + leilao + '/initSyncLocal')
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },

  gerarPlanilhaNotas (leilao) {
    return http.get(`/api/leiloes/${leilao}/gerar-planilha-notas-arremate`)
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },
  gerarPlanilha005 (leilao) {
    return http.get(`/api/leiloes/${leilao}/gerar-planilha-005`)
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },
  prepararLeilao (leilao, diasNoPatio = 30, tipoProcesso) {
    return http.get('/api/leiloes/analisar-lotes-validos?leilao=' + leilao + '&diasNoPatio=' + diasNoPatio + '&tipoProcesso=' + tipoProcesso)
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },
  gerarLotes (leilao, data) {
    return http.post(`/api/leiloes/${leilao}/gerar-lotes`, JSON.stringify({lista: data}))
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },
  gerarLote (leilao, grv, totalSelecionados, excluirRelatorio = false) {
    return http.post(`/api/leiloes/${leilao}/gerar-lote-individual${excluirRelatorio ? '?excluirRelatorio=true' : ''}`, JSON.stringify({grv, totalSelecionados}))
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },
  checarNumeroGrv (numero) {
    return http.post('/api/grv/checar-numero-grv', JSON.stringify({numero}))
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },
  getExtratoLeilaoInfo (lote) {
    return http.get('/api/lote/' + lote + '/extrato-leilao-info')
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },
  getMunicipiosEstadoDetro (estado) {
    return http.get('/api/municipios-estado-detro?estado=' + estado)
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },
  cadastrarExtratoLeilao (loteId, dados) {
    return http.post(`/api/lote/${loteId}/extrato-leilao-cadastrar`, JSON.stringify(dados))
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },
  gerarPlanilhaExtratoLeilao (leilaoId) {
    return http.get(`/api/leilao/${leilaoId}/gerar-extrato-leilao`)
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },
  cadastrarVistoria (leilaoId) {
    return http.post(`/api/lote/${leilaoId}/cadastrar-vistoria`)
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },
  alterarStatusAparecerNaHome (leilaoId, status) {
    return http.patch(`/api/leilao/${leilaoId}/forcar-mostrar-na-home`, JSON.stringify({show: status}))
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },
  executarConsultaDadosLote (loteId) {
    return http.post(`/api/lote/${loteId}/consulta-lote-individual-detro`)
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },
  buscarHistoricoLeiloesLote (filtro) {
    return http.get(`/api/leiloes/historico-leiloes-lote?filtro=${filtro}`)
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },
  gerarArquivoRemessa (leilao) {
    return http.get(`/api/leiloes/${leilao}/gerar-arquivo-remessa`)
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },
  alterarArrematante (loteId, arrematanteId) {
    return http.patch(`/api/leiloes/lotes/${loteId}/alterar-arrematante`, {arrematante: arrematanteId})
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },
  uploadCsvPlacas (leilaoId, file) {
    return http.post(`/api/leiloes/${leilaoId}/upload-arquivo-placas-para-gerar-lotes`, file, {headers: {'Content-Type': 'multipart/form-data'}}) // ?XDEBUG_SESSION_START=ps
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },
  getDadosImportacaoCsvGrvs (leilao) {
    return http.get(`/api/leiloes/${leilao}/show-log-importacao-csv-placas`)
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },
  uploadCsvImportacaoSecundaria (leilaoId, file) {
    return http.post(`/api/leiloes/${leilaoId}/importacao-secundaria`, file, {headers: {'Content-Type': 'multipart/form-data'}}) // ?XDEBUG_SESSION_START=ps
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },
  getDadosImportacaoSecundaria (leilao) {
    return http.get(`/api/leiloes/${leilao}/show-log-importacao-secundaria`)
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },
  getPublicLinkRemessaS3 (token) {
    return http.get(`/api/download-arquivo-remessa?token=${token}`)
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },
  getDestinatarios (leilaoId) {
    leilaoId = parseInt(leilaoId)
    if (leilaoId < 1) return Promise.reject()
    return http.get(`/api/leilao/${leilaoId}/lote-entidade`) // ?XDEBUG_SESSION_START=ps
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  }

}



// WEBPACK FOOTER //
// ./src/domain/leiloes/services/index.js